import { AbstractRouterFilter } from '@zk/framework-vue';
import 'nprogress/nprogress.css'; // progress bar style
import NProgress from 'nprogress';
NProgress.configure({ showSpinner: false });

export default class LoadingBarFilter extends AbstractRouterFilter {
  order() {
    return super.order();
  }

  onBefore() {
    NProgress.start();
  }

  onAfter() {
    NProgress.done();
  }
}
